import React, { Component } from 'react';
import { Form, Field, change } from 'redux-form';
import { Grid, Row, Col } from 'react-bootstrap';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import StyledLabel from 'components/atoms/inputs/Label';
import ButtonStandardPrimary from 'components/atoms/buttons/standard/Primary';
import FormHeading from 'components/atoms/form/FormHeading';
import FileInput from 'components/atoms/inputs/FileInput';

const StyledGrid = styled(Grid) `
     font-size: 1em;
     padding-top: 16px;
     margin-left: -15px;
     line-height: 16px;
     color: #000000;
`;

class EditEntityBrandingForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            logoUrl: get(props, 'entity.branding.logoUrl', null),
        };
    }

    logoChangeCallBack = (data, remove) => {
        this.setState({
            ...this.state,
            logoUrl: remove ? null : data,
        });
        if (remove) this.props.dispatch(change('editEntityBranding', 'branding.removeLogo', true));
    }

    render() {
        const { pristine } = this.props;
        return (
            <Form onSubmit={this.props.handleSubmit()} id="editEntityBrandingForm">
                <StyledGrid fluid>
                    <FormHeading>Edit Branding for {this.props.entity.name} </FormHeading>
                    <Row>
                        <Col md={6}>
                            <StyledLabel>Entity Logo</StyledLabel><br/>
                            <Field component={FileInput}
                                name='branding.image' label='image' type='file' entityIdAttr={this.props.entity.id} logoCallback={this.logoChangeCallBack}
                                logoUrl={this.state.logoUrl || null } />
                            <br />
                        </Col>
                    </Row>
                    <br/>
                    <ButtonStandardPrimary disabled={pristine} type="submit">Submit</ButtonStandardPrimary>
                </StyledGrid>
            </Form>
        );
    }
}

EditEntityBrandingForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    entity: PropTypes.object
};

export default EditEntityBrandingForm;



// WEBPACK FOOTER //
// ./src/components/organisms/forms/EditEntityBranding.js